import { render, staticRenderFns } from "./OrderOtherMain.vue?vue&type=template&id=4baf1dec&scoped=true&"
import script from "./OrderOtherMain.vue?vue&type=script&lang=js&"
export * from "./OrderOtherMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf1dec",
  null
  
)

export default component.exports